var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 64,
    viewBox: "0 0 66 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0837 3.5612C30.0837 1.9512 28.777 0.644531 27.167 0.644531H3.83366C2.22366 0.644531 0.916992 1.9512 0.916992 3.5612V26.8945C0.916992 28.5045 2.22366 29.8112 3.83366 29.8112H27.167C28.777 29.8112 30.0837 28.5045 30.0837 26.8945V3.5612Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0837 37.1042C30.0837 35.4942 28.777 34.1875 27.167 34.1875H3.83366C2.22366 34.1875 0.916992 35.4942 0.916992 37.1042V60.4375C0.916992 62.0475 2.22366 63.3542 3.83366 63.3542H27.167C28.777 63.3542 30.0837 62.0475 30.0837 60.4375V37.1042Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.0837 3.5612C65.0837 1.9512 63.777 0.644531 62.167 0.644531H38.8337C37.2237 0.644531 35.917 1.9512 35.917 3.5612V26.8945C35.917 28.5045 37.2237 29.8112 38.8337 29.8112H62.167C63.777 29.8112 65.0837 28.5045 65.0837 26.8945V3.5612Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.584 37.1042V60.4375C47.584 62.0475 48.8907 63.3542 50.5007 63.3542C52.1107 63.3542 53.4173 62.0475 53.4173 60.4375V37.1042C53.4173 35.4942 52.1107 34.1875 50.5007 34.1875C48.8907 34.1875 47.584 35.4942 47.584 37.1042Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.8337 51.6849H62.167C63.777 51.6849 65.0837 50.3782 65.0837 48.7682C65.0837 47.1582 63.777 45.8516 62.167 45.8516H38.8337C37.2237 45.8516 35.917 47.1582 35.917 48.7682C35.917 50.3782 37.2237 51.6849 38.8337 51.6849Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.fbcd17a77a71a06a0a84da167536147c.svg";
export { ForwardRef as ReactComponent };